import { useState, useRef } from 'react';
import { isDesktop, isTablet, isMobile } from 'react-device-detect';
import { useSpring, animated } from "react-spring";
import 'intersection-observer'
import { useIsVisible } from 'react-is-visible';
import { Parallax, ParallaxLayer } from '@react-spring/parallax';
import gradientBg from '../../_assets/_img/bg.png';
import tallClouds from '../../_assets/_img/03-clouds-articles-1-3.png';
import huluLogo from '../../_assets/_img/hulu-logo.svg';
import twitter from '../../_assets/_img/twitter.svg';
import ig from '../../_assets/_img/ig.svg';
import hmtBg from '../../_assets/_img/desktop-flower.png';
import fb from '../../_assets/_img/icons/fb-dark.svg';
import ScrollDown from '../ScrollDown/ScrollDown';
import './App.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import silouette from '../../_assets/_img/habib-dadkhah-REBIdR3c2DE-unsplash.png'

const styling = isVisible => ({
  color: isVisible ? "#690A04" : "#690A04",
  transition: "color 2s ease"
});

const SomeComponent = props => {
  const nodeRef = useRef();
  const isVisible = useIsVisible(nodeRef);
  return (
    <p ref={nodeRef} className={`${isVisible ? 'visible' : ''}`} {...props}>
      <span style={styling(isVisible)} className="white-gradient">There's nothing more important than the ability to know... that you're not your life's mistakes</span><br></br>
    </p>
  );
};

const AnotherComponent = props => {
  const nodeRef = useRef();
  const isVisible = useIsVisible(nodeRef);
  return (
    <p ref={nodeRef} className={`${isVisible ? 'visible' : ''}`} {...props}>
      <span style={styling(isVisible)} className="white-gradient">Freedom is a question of life.</span><br></br>
      <span className="red-gradient"> If you don't reach for it, you are not alive.</span>
    </p>
  );
};

function App() {
  let parallax = useRef();
  const [key, setKey] = useState(1);
  const scrolling = useSpring({
    from: { transform: "translate(0%,0)" },
    to: { transform: "translate(-25%,0)" },
    config: { duration: 30000 },
    reset: true,
    // //reverse: key % 2 == 0,
    onRest: () => {
      setKey(key + 1);
    }
  });

  const scrollingTwo = useSpring({
    from: { transform: "translate(0%,0)" },
    to: { transform: "translate(-25%,0)" },
    config: { duration: 60000 },
    reset: true,
    //reverse: key % 2 == 0,
    onRest: () => {
      setKey(key + 1);
    }
  });
  const growHeight = useSpring({
    from: { height: 0},
    to: { height:  isDesktop || isTablet ? 350 : 650},
    config: {
      duration: 1000
    },
    delay: 3000
  });

  const fadeIn = useSpring({
    from: { opacity: 0},
    to: { opacity:  1 },
    config: {
      duration: 1000
    },
    delay: 3000
  });

  const largeTextFadeOutMobile = useSpring({
    from: {
      opacity: 1
    },
    to: {
      opacity: isDesktop ? 1 : 0
    },
    delay: 3000
  })
  const smallTextIn = useSpring({
    from: {
      display: 'block'
    },
    to: {
      display: isDesktop ? 'none' : 'block'
    },
    delay: 3000
  })

  const changeTopPadding = useSpring({
    from: {
      paddingTop: isMobile ? '50vh' : ''
    },
    to: {
      paddingTop: isMobile ? '20vh' : ''
    },
    delay: 3000
  })
  return (
    <div>
      <Header />
      <img src={huluLogo} className="logo-desktop"/>
      <Parallax ref={ref => (parallax = ref)} pages={isMobile ? 8 : 6.2}>

        <ParallaxLayer offset={1} speed={.25} factor={8} style={{ backgroundImage: `url(${tallClouds})`, backgroundSize: 'cover' }} />
        
        <ParallaxLayer
          offset={0}
          speed={0.1}
          factor={isMobile ? 1.7 : 1}
          className="parallax-layer parallax-layer--special"
          style={{ backgroundImage: `url(${gradientBg})`, backgroundSize: 'cover' }}
          >
            <img className="logo" src={huluLogo} />
            <animated.div className="hero container" style={changeTopPadding}>
              <animated.p className="large-text" style={largeTextFadeOutMobile}>Freedom is </animated.p>
              <animated.div style={growHeight} className="aux-text">
                <p><animated.span style={smallTextIn} className="bold">Freedom is just the beginning. </animated.span><span>Just as oppression manifests itself in many different ways—subtly, overtly, systematically, individually—so does its foil: liberation. Any woman who has fought for her rights knows that even with your first glimpse of freedom, the journey ahead can be long and complicated.</span></p>
                <p>In this ongoing series, presented by Hulu’s <span className="italics">The Handmaid’s Tale</span>, we’ll meet women from all walks of life who have had their personal liberties threatened through political suppression, displacement, and incarceration. Despite these barriers and toll exacted in their journeys, they’ve continued to fight—not just for themselves, but for the freedom of others.</p>
              </animated.div>
              <animated.p className="large-text large-text--right" style={largeTextFadeOutMobile}>just the beginning</animated.p>
            </animated.div>
            <ScrollDown />
            <animated.div style={fadeIn} className="clouds"></animated.div>
            <div className="ticker">
              <animated.div style={scrolling}>
                <animated.span>May the world open</animated.span>
                <animated.span>May the world open</animated.span>
                <animated.span>May the world open</animated.span>
                <animated.span>May the world open</animated.span>
              </animated.div>
            </div>
        </ParallaxLayer>
        <ParallaxLayer
          offset={isMobile ? 1.5 : 1}
          speed={0}
          className="parallax-layer">
          <div className="container container--other">
            <p className={`knockout-text`}>
              <AnotherComponent></AnotherComponent>
            </p>
          <div className="author">
            <span className="red-line"></span>
            <span>Emi Mahmoud</span>
          </div>
          </div>
        </ParallaxLayer>

        <ParallaxLayer 
          offset={isMobile ? 2.8 : 2}
          speed={0.13}
          className="parallax-layer">
            <div className="story-section container">
            <iframe src="https://player.vimeo.com/video/541727124" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            <p className="title">Emi's Journey</p>
            <p>When Sudanese-American poet and activist Emtithal ‘Emi’ Mahmoud was 7 years old, she found herself hiding under the bed at her family home in Darfur as bullets rained down around her.</p>
            <a className="read-more" rel="noreferrer" href="https://sponsorcontent.cnn.com/interactive/huluhandmaidstale/freedomjourneys/poetactivist/" target="_blank">
              <span className="line"></span>
              <p className="">READ HER STORY</p>
            </a>
            <div className="socials">
              <a target="_blank" href="https://twitter.com/EmiThePoet"><p><img src={twitter} /> @EMITHEPOET</p></a>
              <a target="_blank" href="https://www.instagram.com/emibattuta/?hl=en"><p><img src={ig} /> @EMIBATTUTA</p></a>
            </div>
          </div>
        </ParallaxLayer>

        <ParallaxLayer 
          offset={isMobile ? 3.9 : 3.2}
          factor={isMobile ? 1.3 : 1}
          speed={0.13}
          className="parallax-layer cta-layer">
            <div className="cta-container">

              <p className="cta-title">How Women Refugees Are Changing Their Own Narrative</p>
              <div className="image-flex">
                <div>
                  <img src={silouette} />
                </div>
                <div>
                  <p className="cta-quote">“You will never forget what happened… but you can move from being a victim to being a survivor...”</p>
                </div>
              </div>
              <a href="https://sponsorcontent.cnn.com/interactive/huluhandmaidstale/freedomjourneys/refugeementalhealth/" target="_blank">
                <div className="button">
                <p>Read Article</p>
                </div>
              </a>
            </div>

            <div className="ticker ticker--other">
                <animated.div style={scrollingTwo}>
                  <animated.span>The Handmaid’s Tale | New Season Now Streaming On Hulu</animated.span>
                  <animated.span>The Handmaid’s Tale | New Season Now Streaming On Hulu</animated.span>
                  <animated.span>The Handmaid’s Tale | New Season Now Streaming On Hulu</animated.span>
                  <animated.span>The Handmaid’s Tale | New Season Now Streaming On Hulu</animated.span>
                </animated.div>
              </div>
        </ParallaxLayer>


        <ParallaxLayer
          offset={isMobile ? 4.7 : 3.5}
          speed={0}
          className="parallax-layer">
          <div className="container container--other">
            <p className={`knockout-text`}>
              <SomeComponent></SomeComponent>
            </p>
          <div className="author">
            <span className="red-line"></span>
            <span>ANGELICA ZARAGOZA</span>
          </div>
          </div>
        </ParallaxLayer>

        <ParallaxLayer 
          offset={isMobile ? 6.3 : 4.7}
          speed={0.13}
          className="parallax-layer">
            <div className="story-section container">
            <iframe src="https://player.vimeo.com/video/546079813" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            <p className="title">Angelica’s Journey</p>
            <p>The first few times Angelica Zaragoza’s 11-year-old daughter Jalyssa visited her in prison, Jalyssa barely said a word. Angelica had been in and out of jail on drug-related charges for much of Jalyssa’s life, and she carried a lot of resentment towards her mother.</p>
            <a className="read-more" rel="noreferrer" href="https://sponsorcontent.cnn.com/interactive/huluhandmaidstale/freedomjourneys/incarceratedmothers/" target="_blank">
              <span className="line"></span>
              <p className="">READ HER STORY</p>
            </a>
            <div className="socials">
              <a target="_blank" href="https://twitter.com/EmiThePoet"><p><img src={twitter} /> @GirlsEmbracingMothers</p></a>
              <a target="_blank" href="https://www.facebook.com/GEM_AmplifyHER/?hl=en"><p><img src={fb} />@GEM_AmplifyHER</p></a>
              <a target="_blank" href="https://www.instagram.com/girlsembracingmothers/?hl=en"><p><img src={ig} />@girlsembracingmothers</p></a>
            </div>
          </div>
        </ParallaxLayer>
        <ParallaxLayer 
          offset={isMobile ? 7.5: 5.9}
          speed={0.13}
          className="parallax-layer hmt-container"
          style={{ backgroundImage: window.innerWidth >=1024 ? `url(${hmtBg})` : ``, backgroundSize: window.innerWidth >=1024  ? 'cover' : 'contain' }}>
              <div className="ticker ticker--top">
                <animated.div style={scrolling}>
                  <animated.span>Freedom Takes Root</animated.span>
                  <animated.span>Freedom Takes Root</animated.span>
                  <animated.span>Freedom Takes Root</animated.span>
                  <animated.span>Freedom Takes Root</animated.span>
                </animated.div>
              </div>
            <Footer />
        </ParallaxLayer>
      </Parallax>
    </div>
  );
}

export default App;